import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';

import '../../styles/theme.scss';
import '../../styles/theme.scss.liquid';

import $ from 'jquery';
import { pageLinkFocus } from '@shopify/theme-a11y';
import { cookiesEnabled } from '@shopify/theme-cart';
import { wrapTable, wrapIframe } from '@shopify/theme-rte';

import Masonry from 'masonry-layout';
import slider_with_custom_paging from '../slider_with_custom_paging.js';
import slider_with_thumbnails from '../slider_with_thumbnails.js';
import slider_mobile from '../slider_mobile.js';
import slider_products from '../slider-products.js';
import slider from '../slider.js';
import 'magnific-popup';

const $doc = $(document);
const $win = $(window);

let scrollTop = 0;
let positionToShow = $win.height() * 0.9 + scrollTop;
let numProducts = 0;
let adnimationDirection = '';

window.slate = window.slate || {};
window.theme = window.theme || {};

let isMobile = false;
if (
	/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
		navigator.userAgent
	) ||
	/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
		navigator.userAgent.substr(0, 4)
	)
)
	isMobile = true;

$(document).ready(() => {
	// Common a11y fixes
	if (window.location.hash !== '#') {
		pageLinkFocus($(window.location.hash));
	}

	$('.in-page-link').on('click', evt => {
		pageLinkFocus($(evt.currentTarget.hash));
	});

	// Target tables to make them scrollable
	const tableSelectors = '.rte table';

	wrapTable({
		$tables: $(tableSelectors),
		tableWrapperClass: 'rte__table-wrapper'
	});

	// Target iframes to make them responsive
	const iframeSelectors = '.rte iframe[src*="youtube.com/embed"],' + '.rte iframe[src*="player.vimeo"]';

	wrapIframe({
		$iframes: $(iframeSelectors),
		iframeWrapperClass: 'rte__video-wrapper'
	});

	// Apply a specific class to the html element for browser support of cookies.
	if (cookiesEnabled()) {
		document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
	}

	if ($('.list-collections').length) {
		const grid = document.querySelector('.list-collections');
		const msnry = new Masonry(grid);

		if (grid) {
			msnry.layout();
		}
	}

	if (isMobile) {
		$('.nav-lang').toggleClass('is-touch');
	}

	$('#RecoverPassword, .link-popup').each(function() {
		$(this).magnificPopup({
			type: 'inline',
			preloader: false
		});
	});

	$('.popup-trigger, a[href="#popup-menu"]').each(function() {
		$(this).magnificPopup({
			type: 'inline',
			mainClass: 'mfp-light',
			preloader: false
		});
	});

	// Close popup
	$(document).on('click', '.popup__inner .btn-close', function(e) {
		e.preventDefault();
		$.magnificPopup.close();
	});

	if ($('.popup__inner .form__error').length) {
		let id = $('.popup__inner .form__error')
			.closest('.popup__inner')
			.attr('id');
		$('a[href="#' + id + '"]').trigger('click');
	}

	if ($('.section-recently-viewed').length) {
		numProducts = Number($('.section-recently-viewed').data('products-number'));
	}

	if ($('.product-single').length) {
		let handle = $('.product-single').data('handle');

		if (Cookies.get('product_handle')) {
			let products = Cookies.get('product_handle').split(';');
			let newProducts = '';

			if (products.length > numProducts) {
				products = products.splice(0, numProducts);
			}

			for (var i = 0; i < products.length; i++) {
				if (products[i] != handle) {
					newProducts += products[i] + ';';
				}
			}

			Cookies.set('product_handle', handle + ';' + newProducts);
		} else {
			Cookies.set('product_handle', handle);
		}
	}

	if ($('.section-recently-viewed').length) {
		let products = Cookies.get('product_handle').split(';');
		let i = 0;
		ajaxLoading(i, products);
	}

	// slider($slider, dots, arrows, slidesToShow, autoplay)
	slider($('.slider-team'), true, true, 1);
	slider($('.slider-images'), true, true, 1, false);
	slider($('.slider-articles'), false, true, 2);
	slider_mobile($('.section-products-in-use .slider-products'), false, true);
	slider_with_thumbnails($('.slider-product'), true);
	slider_with_custom_paging($('.slider-product-details'), true);

	$doc
		.on('change', '.radio-holder input, .swatch__element input', function() {
			swatchToggle($(this));
		})
		.on('click', '.page-nav a', function(e) {
			// e.preventDefault();
			smoothScroll(this);
		})
		.on('click', '.btn-scroll-top, .link-top', function(e) {
			e.preventDefault();
			smoothScroll(this, 0);
		})
		.on('click', '.btn-close, .address-new-toggle, .address-edit-toggle', function(e) {
			e.preventDefault();
			$.magnificPopup.close();
		})
		.on('change', 'input[name="newsletter_field"]', function(e) {
			if ($('#field-receive-html-mail-text-mail:checked').length) {
				$('#field-newsletter').val('newsletter');
			} else {
				$('#field-newsletter').val('');
			}
		})
		.on('touchend', '.is-touch', function(e) {
			$(this).addClass('expanded');
		})
		.on('focus', '.form-subscribe input', function(e) {
			let id = $(this).attr('id');

			$('label[for="' + id + '"]').hide();
		})
		.on('blur', '.form-subscribe input', function(e) {
			let id = $(this).attr('id');

			if ($(this).val().length == 0) {
				$('label[for="' + id + '"]').show();
			}
		})
		.on('click', '.btn-load-more', function(e) {
			e.preventDefault();

			let container = $(this).data('container');
			let content = $(this).data('content');

			lazyLoading('.btn-load-more', container, content);
		})
		.on('submit', '.product-single form', function(e) {
			e.preventDefault();

			let $form = $(this);
			let $popup = $form.find('.form__popup');

			$popup.toggleClass('popup-bottom', $popup.offset().top - scrollTop < 300);

			$.ajax({
				type: 'POST',
				url: '/cart/add.js',
				dataType: 'json',
				data: $form.serialize(),
				success: function(response) {
					$popup.toggleClass('popup-expanded');
				},
				error: function(data) {
					console.log('error');
				}
			});
		})
		.on('click', '.close-popup', function(e) {
			e.preventDefault();
			$('.popup-expanded').removeClass('popup-expanded');
		})
		.on('click', '.nav-trigger', function(e) {
			e.preventDefault();

			$(this)
				.closest('.header')
				.toggleClass('nav-expanded');
			$('.nav-lang').removeClass('expanded');
		})
		.on('scroll orientationchange', function() {
			scrollTop = $win.scrollTop();

			if ($('.section-guide').length) {
				$('.row').each(function() {
					let activePosition = scrollTop + $('.header').height() + 10;
					let rowTop = $(this).offset().top;
					let rowBottom = rowTop + $(this).height();

					if (rowBottom > activePosition && rowTop <= activePosition) {
						changeHashWithoutScrolling('#' + $(this).attr('id'));

						$(this)
							.addClass('active')
							.siblings()
							.removeClass('active');
					}
				});
			}
		})
		.on('scroll', function() {
			scrollTop = $win.scrollTop();
			$('.btn-scroll-top').toggleClass('shown', scrollTop > $win.height());
		})
		.on('click', '.menu-item-closed > a', function(e) {
			e.preventDefault();

			$('.menu-item-has-children').each(function() {
				$(this).addClass('menu-item-closed');
			});

			$(this)
				.parent()
				.removeClass('menu-item-closed');

			$('.form-expanded').removeClass('form-expanded');
		})
		.on('click', '.nav-trigger', function(e) {
			e.preventDefault();

			$('.wrapper').toggleClass('nav-expanded');
			let $elements = $('.nav-wrapper .nav .menu > li > a, .nav-wrapper .nav-access a, .nav-wrapper .form-search, .nav-wrapper .nav-lang');
			cascadeAnimation($elements);
			closeDropdown();
		})
		.on('click', '.menu-trigger, .collection-popup .btn-close', function(e) {
			e.preventDefault();
			$('body').toggleClass('popup-expanded');
			$('.collection-popup').fadeToggle();
		})
		.on('click', '.accordion__head', function(e) {
			e.preventDefault();

			accordionToggle($(this));
		})
		.on('click', '.btn-search-trigger, .form-search .btn-close', function(e) {
			e.preventDefault();

			closeDropdown();
			$('.form-search').toggleClass('form-expanded');
		})
		.on('click', '.nav__label', function(e) {
			e.preventDefault();

			$(this)
				.parent()
				.toggleClass('expanded');
		})
		.on('click', '.plus, .minus', function(e) {
			quantityUpdate($(this));
		})
		.on('change', '.section-cart input', function() {
			cartUpdate($(this));
		})
		.on('submit', '#create_customer', function(e) {
			let $form = $(this);
			let $formInput = $form.find('.form__row--required input');

			$formInput.each(function() {
				inputValidate($(this));
			});

			emailValidate($form);
			passwordValidate($form);

			console.log($form.find('.form__row--error').length);

			if ($form.find('.form__row--error').length > 0) {
				e.preventDefault();
			}
		})
		.on('submit', '#contact_form', function(e) {
			let $form = $(this);
			let $formInput = $form.find('.form__row--required .form__controls > input');
			let $formTextarea = $form.find('.form__row--required .form__controls > textarea');
			let $formCheckboxes = $form.find('.form__row--required .list-checkboxes');
			let $formRadios = $form.find('.form__row--required .list-radios');

			$formCheckboxes.add($formRadios).each(function() {
				let $formRow = $(this).closest('.form__row');

				if ($(this).find('input:checked').length == 0) {
					$formRow.addClass('form__row--error form__row--error-list');
				} else {
					$formRow.removeClass('form__row--error form__row--error-list');
				}
			});

			$formInput.add($formTextarea).each(function() {
				inputValidate($(this));
			});

			let $email = $form.find('input[name="contact[email]"]');
			let $emailConfirmation = $form.find('input[name="contact[email_confirm]"]');

			if ($email.val() != $emailConfirmation.val()) {
				$email
					.add($emailConfirmation)
					.closest('.form__row')
					.addClass('form__row--error');
			}

			if ($(this).find('.form__row--error').length) {
				e.preventDefault();
			}
		})
		.on('submit', '#RecoverPasswordForm form', function(e) {
			let $form = $(this);
			let $formInput = $form.find('.form__row--required input');

			$formInput.each(function() {
				inputValidate($(this));
			});

			if ($(this).find('.form__row--error').length) {
				e.preventDefault();
			}
		})
		.on('blur', '#create_customer input', function(e) {
			let $form = $('#create_customer');
			inputValidate($(this));
		})
		.on('blur', '#create_customer input[name="customer[email_confirmation]"]', function(e) {
			let $form = $('#create_customer');
			emailValidate($form);
		})
		.on('blur', '#create_customer input[name="customer[password_confirmation]"]', function(e) {
			let $form = $('#create_customer');
			passwordValidate($form);
		});

	$win
		.on('load resize scroll', function() {
			scrollTop = $win.scrollTop();
			positionToShow = $win.height() * 0.9 + scrollTop;

			elementsAnimation($('.fadeInUp'), scrollTop, positionToShow, 1);
		})
		.on('load resize', function() {
			if (isMobile || $win.width() < 1025) {
				closeDropdown();
			}
		});
});

$win.on('load', function() {
	$('.loader').fadeOut();
});

function accordionToggle($accordionHead) {
	$accordionHead
		.next()
		.slideToggle()
		.closest('.accordion__section')
		.toggleClass('expanded')
		.siblings()
		.removeClass('expanded')
		.find('.accordion__body')
		.slideUp();
}

function cartUpdate($input) {
	let $form = $input.closest('form');
	let $popup = $form.find('.form__popup');

	$.ajax({
		type: 'POST',
		url: '/cart/update.js',
		dataType: 'json',
		data: $form.serialize(),
		success: function(response) {
			location.reload();
		},
		error: function(data) {
			console.log('error');
		}
	});
}

function quantityUpdate($this) {
	let $quantity = $this.closest('.quantity');
	let $qty = $quantity.find('span.qty');
	let $input = $quantity.find('input.qty');
	let val = parseInt($input.val());
	let step = parseInt($this.attr('step'));

	if (val > 0 || (val == 0 && step == 1)) {
		val += step;
		$input.val(val).change();
		$qty.html(val);
	}
}

function emailValidate($form) {
	let $email = $form.find('input[name="customer[email]"]');
	let $emailConfirmation = $form.find('input[name="customer[email_confirmation]"]');

	if ($email.val() != $emailConfirmation.val()) {
		$email
			.add($emailConfirmation)
			.closest('.form__row')
			.addClass('form__row--error');
	}
}

function passwordValidate($form) {
	let $password = $form.find('input[name="customer[password]"]');
	let $passwordConfirmation = $form.find('input[name="customer[password_confirmation]"]');

	if ($password.val().length < 8 || $passwordConfirmation.val().length < 8 || $password.val() != $passwordConfirmation.val()) {
		$password
			.add($passwordConfirmation)
			.closest('.form__row')
			.addClass('form__row--error');
	}
}

function inputValidate($input) {
	let $formRow = $input.closest('.form__row');

	if ($input.val().length == 0) {
		$formRow.addClass('form__row--error');
	} else {
		$formRow.removeClass('form__row--error');
	}
}

function swatchToggle($input) {
	var $productSelect = $('#product-select');
	var option_target = '';
	var $form = $input.closest('form');
	var $btnSubmit = $form.find('.btn-submit');
	var $btnSoldOut = $form.find('.btn-sold-out');
	var $swatch = $form.find('.swatch');
	var $formHint = $form.find('.form_hint');
	var $formHintTitle = $formHint.find('.title');
	var $formHintSKU = $formHint.find('.sku');
	var $price = $form.find('.price');
	var $isAvailable = $form.find('.is_available');

	$('.radio-holder input:checked').each(function() {
		var $this = $(this);
		var dataIndex = $this.data('index');
		var eleValue = $this.val();
		option_target += `[data-option-${dataIndex}="${eleValue}"]`;
	});

	var selectedVal = $productSelect.find(option_target).val();
	$productSelect.val(selectedVal);

	var $option = $('#product-select option:selected');

	var elementIsAvailable = $option.data('available');
	var elementPrice = $option.data('price');
	var elementSelector = $option.data('selector');
	var elementTitle = '';
	var elementSku = $option.data('sku');

	$isAvailable.toggleClass('hide', elementIsAvailable);
	$btnSubmit.toggleClass('hide', !elementIsAvailable);
	$btnSoldOut.toggleClass('hide', elementIsAvailable);

	$formHintSKU.html(elementSku);
	$price.html(elementPrice);

	$('.radio-holder input:checked').each(function() {
		elementTitle =
			elementTitle +
			$(this)
				.next('label')
				.html()
				.toLowerCase() +
			' / ';
	});

	$formHintTitle.html(elementTitle.substring(0, elementTitle.length - 3));

	if ($swatch) {
		$('a.color-' + elementSelector).trigger('click');
	}
}

function smoothScroll(linkDOM, scrollPosition) {
	linkDOM = linkDOM || location;

	if (linkDOM.hash && (location.pathname == linkDOM.pathname || location.hostname == linkDOM.hostname)) {
		var target = $(linkDOM.hash);

		if (target.length) {
			if (scrollPosition == undefined) {
				scrollPosition = target.offset().top - $('.header').height();
			}

			$('html,body').animate(
				{
					scrollTop: scrollPosition //Scroll to position
				},
				1000
			);

			return false;
		}
	}
}

function lazyLoading(click, container, content) {
	if (typeof callback === 'Function') {
		callback();
	}

	var $nextPageLink = $(click);
	if (!$nextPageLink.length) {
		return false;
	}

	$.ajax({
		url: $nextPageLink.attr('href')
	})
		.done(function(response) {
			let $newContent = $(response)
				.find(content)
				.addClass('loading');
			let responseNext = $(response).find(click);

			$newContent.appendTo($(container));

			console.log($(content).length % 3);

			if ($(content).length % 3 == 2) {
				$(container).removeClass('hide-1 hide-2');
			} else if ($(content).length % 3 == 1) {
				$(container)
					.addClass('hide-2')
					.removeClass('hide-1');
			} else {
				$(container)
					.addClass('hide-1')
					.removeClass('hide-2');
			}

			if (responseNext.length > 0) {
				$nextPageLink.attr('href', responseNext.attr('href'));
			} else {
				$nextPageLink.remove();
				$(container).removeClass('hide-1 hide-2');
			}

			setTimeout(function() {
				$('.loading').removeClass('loading');
			});
		})
		.fail(function(jqXHR, error, status) {
			console.log('error');
		});
}

function closeDropdown() {
	$('.menu-item-has-children').each(function() {
		$(this).addClass('menu-item-closed');
	});
}

function elementsAnimation($elements, scrollTop, positionToShow, seconds) {
	let secondsDelay = seconds;

	$elements.each(function(i) {
		let $elem = $(this);
		let elemTop = $elem.offset().top;
		let elemBottom = elemTop + $elem.height();

		if (elemTop <= positionToShow) {
			let delay = i * secondsDelay;

			setTimeout(
				function($elem) {
					$elem.addClass('animated');
				},
				delay,
				$(this)
			);
		}
	});
}

function ajaxLoading(i, products) {
	let productHandle = products[i];

	$.ajax({
		type: 'GET',
		url: '/products/' + productHandle + '.js',
		dataType: 'json',
		success: function(response) {
			let featured_image = response.featured_image;
			let url = response.url;
			let title = response.title;

			let html =
				'<div class="slider__slide product loading">' +
				'<a href="' +
				url +
				'">' +
				'<span class="product__media" style="background-image: url(' +
				featured_image +
				'); "></span>' +
				'<h4 class="product__title">' +
				title +
				'</h4>' +
				'</a>' +
				'</div>';

			$('.section-recently-viewed .slider__slides').append(html);

			i += 1;

			if (i < numProducts) {
				ajaxLoading(i, products);
			} else {
				i = 0;
			}

			$('.loading').removeClass('loading');

			slider_products($('.slider-articles'), false, true, 5);
		},
		error: function(data) {
			console.log(data);
		}
	});
}

function cascadeAnimation($elements) {
	$elements.each(function(index) {
		let length = $elements.length;
		let $element = $(this);

		if (adnimationDirection == 'reversed') {
			setTimeout(function() {
				$element.toggleClass('animated');
			}, 50 * (length - index));
		} else {
			setTimeout(function() {
				$element.toggleClass('animated');
			}, 50 * index);
		}
	});

	if (adnimationDirection == 'reversed') {
		adnimationDirection = '';
	} else {
		adnimationDirection = 'reversed';
	}
}

function changeHashWithoutScrolling(hash) {
	var id = hash.replace(/^.*#/, ''),
		elem = document.getElementById(id);
	elem.id = id + '-tmp';
	window.location.hash = hash;
	elem.id = id;
}
